const responseMap = {
  Connect: 'Connected',
  Pending: 'Invited',
  Decline: 'Declined'
}
export default function mapResponse(response) {
  return responseMap[response] || response;
};
